import React, { ReactElement } from "react";
import Layout from "Layout";
import CreditMemoForm from "./CreditMemoForm";
import styles from "./styles.module.scss";

function CreditMemos(): ReactElement {
  return (
    <Layout>
      <div className={styles.addNewOrderPageInfo}>
        <h1>Statement Of Account</h1>
        <div className={styles.barContainer}>
          <div className={styles.bar} />
        </div>
        <div className={styles.addNewOrderForm}>
          <CreditMemoForm />
        </div>
      </div>
    </Layout>
  );
}

export default CreditMemos;
